// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn___xtdR","listService_mobile":"style_listService_mobile__1CtNA","img":"style_img__3pjJU"};